import { constant } from 'lodash/fp';
import { useQueryClient } from '@tanstack/react-query';
import { TextKey } from '@mews-commander/enums';
import { WithOwnerId, WithScope } from '@mews-commander/types';
import { deleteRestriction } from '../../../actions';
import { createDeleteDialogConnect } from '../../../../entityManagement';
import EntityDeleteDialog from '../../../../entityManagement/components/EntityDeleteDialog';
import { RESTRICTIONS_CALENDAR_QUERY_KEY } from '../../../queries';

type Props = Parameters<typeof EntityDeleteDialog>[0] & WithOwnerId & WithScope;

const RestrictionDeleteConfirmationDialog = ({ onConfirmation, ...other }: Props) => {
    const queryClient = useQueryClient();

    const handleConfirmation = async () => {
        if (onConfirmation) {
            await onConfirmation();
            await queryClient.invalidateQueries({
                queryKey: RESTRICTIONS_CALENDAR_QUERY_KEY,
            });
        }
    };

    return <EntityDeleteDialog onConfirmation={handleConfirmation} {...other} />;
};

export default createDeleteDialogConnect(
    constant(TextKey.Restriction),
    deleteRestriction
)(RestrictionDeleteConfirmationDialog);
